import type { AppMeasurement } from "./AdobeAnalytics"

const MILLISECONDS = 10 * 1000

export function waitForAppMeasurement(callback: (appMeasurement: AppMeasurement) => void) {
	let timeout: NodeJS.Timeout
	const start = Date.now()

	function checkAdobeAvailability() {
		const W = window
		if (!W.s) {
			const now = Date.now()
			if (now > start + MILLISECONDS) {
				// Abort if app measurement isn't loaded after a certain time
				return
			}

			timeout = setTimeout(checkAdobeAvailability, 20)
			return
		}

		callback(W.s)
	}

	checkAdobeAvailability()

	return () => {
		clearTimeout(timeout)
	}
}
